import React from 'react';

const PhaseSidebar = ({
  phases,
  selectedPhaseId,
  onSelectPhase,
  getPhaseProgress,
  submissionStatus,
  isCollapsed,
  setIsCollapsed,
  selectedProgress,
  isLocked,
  darkMode,
  theme,
}) => {
  return (
    <div className={`sticky top-0 z-40 mb-5 rounded-lg shadow ${theme.panel}`}>
      <div className={`p-4 border-b ${theme.panelMuted}`}>
        <div className="flex items-center justify-between gap-3">
          <h2 className={`font-bold ${theme.heading}`}>Assigned BCM Phases</h2>
          <button
            type="button"
            onClick={() => setIsCollapsed((p) => !p)}
            className="px-3 py-2 rounded-lg bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold transition"
          >
            {isCollapsed ? 'Show Phases' : 'Hide Phases'}
          </button>
        </div>
      </div>

      {!isCollapsed && (
        <div className="p-3 flex flex-wrap gap-2">
          {phases.map((phase) => {
            const p = getPhaseProgress(phase.id);
            const selected = selectedPhaseId === phase.id;
            const submitted = submissionStatus[phase.id] === 'submitted';

            const baseClass = darkMode
              ? 'bg-gray-800 border-gray-700 hover:border-amber-500 text-gray-100'
              : 'bg-white border-gray-300 hover:border-amber-600 text-gray-900';

            const selectedClass = darkMode
              ? 'bg-amber-900/30 border-amber-500 text-white'
              : 'bg-amber-100 border-amber-600 text-gray-900';

            const submittedClass = darkMode
              ? 'bg-green-900/20 border-green-600 text-green-100 hover:border-green-500'
              : 'bg-green-50 border-green-500 text-green-900 hover:border-green-600';

            const fullTitle = phase?.title ? `${phase.code} - ${phase.title}` : `${phase.code}`;

            return (
              <button
                key={phase.id}
                onClick={() => onSelectPhase(phase.id)}
                title={fullTitle}
                className={`group px-3 py-2 rounded-lg border text-left text-sm transition min-w-[130px] max-w-[170px] ${
                  submitted ? submittedClass : selected ? selectedClass : baseClass
                }`}
                aria-label={fullTitle}
              >
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    <div className="font-semibold leading-tight truncate">{phase.code}</div>
                    <div className={`text-xs mt-1 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                      {p.answered}/{p.total}
                    </div>
                  </div>

                  {submitted && (
                    <span
                      className={`text-[10px] px-2 py-0.5 rounded-full font-bold whitespace-nowrap ${
                        darkMode ? 'bg-green-800 text-green-100' : 'bg-green-100 text-green-800'
                      }`}
                    >
                      Submitted
                    </span>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      )}

      <div className="p-4">
        <p className={`text-sm mb-2 ${theme.mutedText}`}>
          Progress: <strong>{selectedProgress.answered}/{selectedProgress.total}</strong> ({selectedProgress.percentage}%)
        </p>
        <div className={`w-full rounded-full h-3 overflow-hidden ${theme.progressTrack}`}>
          <div
            className={`h-3 transition-all duration-500 ${
              selectedProgress.percentage < 40
                ? 'bg-red-500'
                : selectedProgress.percentage < 70
                ? 'bg-yellow-500'
                : 'bg-green-600'
            }`}
            style={{ width: `${selectedProgress.percentage}%` }}
          />
        </div>
        <div className="mt-2 text-xs">{isLocked ? '✅ Submitted' : '📝 Draft'}</div>
      </div>
    </div>
  );
};

export default PhaseSidebar;